import { sendRequest } from "@/src/core/http-client"
import { SingleResponse } from "@/src/core/response"

export class CustomerService {
    static async authCustomer(request: Customer.AuthRequest, appAccessToken?: string): Promise<SingleResponse<Customer.AuthResponse>> {
        return sendRequest<Customer.AuthResponse>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/auth`,
            'POST',
            request
        )
    }

    static async getCustomer(customerId: string, accessToken: string, appAccessToken?: string): Promise<SingleResponse<Customer.Response>> {
        return sendRequest<Customer.Response>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/${customerId}`,
            'GET',
            undefined,
            accessToken
        )
    }

    static async exists(appAccessToken: string, merchantId: string, email?: string, phone?: string, customerId?: string): Promise<SingleResponse<boolean>> {
        return sendRequest<boolean>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/exists?MerchantId=${merchantId}&${email ? `Email=${encodeURIComponent(email)}` : phone ? `Phone=${phone}` : `CustomerId=${customerId}`}`,
            'GET'
        )
    }

    static async createCustomer(request: Customer.CreateCustomerRequest, appAccessToken?: string): Promise<SingleResponse<Customer.AuthResponse>> {
        return sendRequest<Customer.AuthResponse>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers`,
            'POST',
            request
        )
    }

    static async updateCustomer(request: Customer.UpdateCustomerRequest, accessToken?: string): Promise<SingleResponse<string>> {
        return sendRequest<string>(
            undefined,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/${request.customerId}`,
            'PUT',
            request,
            accessToken
        )
    }

    static async updateCustomerPassword(customerId: string, request: Customer.UpdateCustomerPasswordRequest, accessToken?: string, appAccessToken?: string): Promise<SingleResponse<Customer.Response>> {
        return sendRequest<Customer.Response>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/${customerId}/password`,
            'PUT',
            request,
            accessToken
        )
    }

    static async createGuestCustomer(request: Customer.CreateGuestCustomerRequest, appAccessToken?: string): Promise<SingleResponse<Customer.AuthResponse>> {
        return sendRequest<Customer.AuthResponse>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/guest`,
            'POST',
            request
        )
    }

    static async createSocialCustomer(request: Customer.CreateSocialCustomerRequest, appAccessToken?: string): Promise<SingleResponse<Customer.AuthResponse>> {
        return sendRequest<Customer.AuthResponse>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/social`,
            'POST',
            request
        )
    }

    static async refresh(refreshToken: string, appAccessToken?: string): Promise<SingleResponse<Customer.RefreshResponse>> {
        return sendRequest<Customer.RefreshResponse>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/auth/refresh`,
            'POST',
            undefined,
            refreshToken
        )
    }

    static async createAddress(customerId: string, request: Customer.CreateAddressRequest, accessToken?: string, appAccessToken?: string): Promise<SingleResponse<Customer.AddressResponse>> {
        return sendRequest<Customer.AddressResponse>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/${customerId}/addresses`,
            'POST',
            request,
            accessToken
        )
    }

    static async deleteAddress(customerId: string, addressId: number, accessToken?: string, appAccessToken?: string): Promise<SingleResponse<boolean>> {
        return sendRequest<boolean>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/${customerId}/addresses/${addressId}`,
            'DELETE',
            undefined,
            accessToken
        )
    }

    static async deleteCustomer(customerId: string, accessToken?: string, appAccessToken?: string): Promise<SingleResponse<boolean>> {
        return sendRequest<boolean>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/${customerId}`,
            'DELETE',
            undefined,
            accessToken
        )
    }

    /** Envia o código OTP ao e-mail. */
    static async OtpRequest(merchantId: string, email: string, appAccessToken?: string): Promise<SingleResponse<any>> {
        return sendRequest<any>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/auth/otp/request`,
            'POST',
            {
                merchantId: merchantId,
                email: email
            },
        )
    }

    /** Valida o OTP enviado ao e-mail. */
    static async OtpAuth(request: Customer.OtpRequest, appAccessToken?: string): Promise<SingleResponse<Customer.AuthResponse>> {
        return sendRequest<Customer.AuthResponse>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/auth/otp`,
            'POST',
            request,
        )
    }

    static async forgotPassword(merchantId: string, customerEmail: string, appAccessToken?: string): Promise<SingleResponse<any>> {
        return sendRequest<any>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/forgot-password`,
            'POST',
            {
                merchantId: merchantId,
                customerEmail: customerEmail
            },
        )
    }

    static async resetPassword(merchantId: string, customerToken: string, customerNewPassword: string, appAccessToken?: string): Promise<SingleResponse<any>> {
        return sendRequest<any>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_MERCHANT_URL}/customers/reset-password`,
            'POST',
            {
                merchantId: merchantId,
                customerToken: customerToken,
                customerNewPassword: customerNewPassword
            },
        )
    }
}